module.exports = __webpack_public_path__ + "static/media/me.94f5e7fb.png";